import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BadgeModule, ErrorModule, IconModule, LoadingModule, SharedPipesModule } from '@grid-ui/common';
import { PermissionsModule } from '@grid-ui/permissions';
import { GridSharedPipesModule } from '../shared-ui-components/shared-pipes/shared-pipes.module';
import { HomeComponent, HomeServiceOfferingCardComponent } from './home';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ErrorModule,
    LoadingModule,
    GridSharedPipesModule,
    SharedPipesModule,
    IconModule,
    BadgeModule,
    PermissionsModule,
  ],
  declarations: [HomeComponent, HomeServiceOfferingCardComponent],
  exports: [HomeComponent],
  providers: [],
})
export class HomeModule {}
